import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityTestimonial, testimonial } from './testimonial';

export const SanityTestimonialCarousel = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('testimonialCarousel'),
  _key: z.string(),
  theme: z.enum(['light', 'purple', 'charcoal']),
  eyebrow: z.string().optional().nullable(),
  headline: z.string(),
  testimonials: z.array(SanityTestimonial),
});
export type SanityTestimonialCarousel = z.infer<
  typeof SanityTestimonialCarousel
>;

export const testimonialCarousel = groq`{
    'theme': coalesce(theme, 'light'),
    eyebrow,
    headline,
    testimonials[]-> ${testimonial},
  
}`;
